/*
 * @FilePath     : /fe-eshotel/src/components/field/props.js
 * @Author       : LiYang
 * @Date         : 2021-10-28 17:48:01
 * @LastEditTime : 2021-11-10 16:37:20
 * @LastEditors  : Please set LastEditors
 * @Description  : 公用props
 */

export const lib = {
  value: String,
  placeholder: String,
  placeholderStyle: String,
  textAreaStyle:null,
  placeholderClass: String,
  disabled: Boolean,
  border:Boolean,
  clearable: {
    type: Boolean,
    value: true
  },
  maxlength: {
    type: Number,
    value: -1,
  },
  cursorSpacing: {
    type: Number,
    value: 50,
  },
  autoFocus: Boolean,
  focus: Boolean,
  cursor: {
    type: Number,
    value: -1,
  },
  selectionStart: {
    type: Number,
    value: -1,
  },
  selectionEnd: {
    type: Number,
    value: -1,
  },
  adjustPosition: {
    type: Boolean,
    value: true,
  },
  holdKeyboard: Boolean,
}

export const inputProp = {
  type: {
    type: String,
    value: 'text',
  },
  password: Boolean,
  confirmType: String,
  confirmHold: Boolean,
}

export const textareaProp = {
  autoHeight: {
    type: Boolean,
    value: true
  },
  fixed: Boolean,
  row: Number,
  showConfirmBar: {
    type: Boolean,
    value: true,
  },
  disableDefaultPadding: {
    type: Boolean,
    value: true,
  },
  hasCountDown:{
    type: Boolean,
    value: false,
  }
}